var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,15.7c0-.2,0-.3-.2-.4-.7-.5-1.5-1-2.2-1.5a.45.45,0,0,0-.5,0l-2.2,1.6a.55.55,0,0,0-.3.5,1.07,1.07,0,0,1-.2.6.45.45,0,0,0,0,.5c.8,1.6,1.5,3.2,2.3,4.8.3.5.5,1.1.8,1.7.1-.1.1-.2.2-.3.9-2,1.7-4,2.6-6,.1-.2.1-.3-.1-.4A1.31,1.31,0,0,1,17.8,15.7Z",
    fill: "#cd0124"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,13.1c-2-1.4-4-2.8-5.9-4.1l-.1.1c.1.2.1.3.2.5l2.1,4.5c.2.4.3.8.9.9a.9.9,0,0,0,.5-.1c.6-.5,1.3-.9,1.9-1.4Z",
    style: {
      fill: "#cd0124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm8.1,8.7c-.2,0-.3.1-.4.3-.8,2-1.7,4-2.5,6v.4a1.3,1.3,0,0,1-.8,1.8q-.15,0-.3.3c-.9,2-1.8,4.1-2.6,6.1a.45.45,0,0,0,0,.5,1.26,1.26,0,0,1-.2,1.7,1.22,1.22,0,0,1-1.6.1,1.15,1.15,0,0,1-.3-1.6.64.64,0,0,0,0-.6c-1-2-1.9-4-2.9-6a.7.7,0,0,0-.5-.4,1.28,1.28,0,0,1-.9-1.9.45.45,0,0,0,0-.5C9.2,12.9,8.3,11,7.3,9c0-.1-.1-.2-.4-.2A1.28,1.28,0,0,1,5.8,7.6a1.54,1.54,0,0,1,.9-1.3,1.24,1.24,0,0,1,1.5.5c.1.2.2.2.5.2H21.4c.2,0,.4,0,.5-.3a1.15,1.15,0,0,1,1.4-.5,1.4,1.4,0,0,1,.9,1.2A1.3,1.3,0,0,1,23.1,8.7Z",
    style: {
      fill: "#cd0124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.4a.45.45,0,0,0,.5,0c1.9-1.4,3.8-2.7,5.6-4.1.1-.1.2-.1.2-.2V8H8.7a.77.77,0,0,1,.3.2Z",
    style: {
      fill: "#cd0124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,13.1c.8.6,1.6,1.1,2.4,1.6.2.1.5,0,.8,0,.1,0,.2-.2.2-.3.7-1.6,1.4-3.3,2.1-4.9,0-.1.1-.2.1-.3h-.1C19.8,10.4,17.9,11.7,16,13.1Z",
    style: {
      fill: "#cd0124"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChz);
export default __webpack_public_path__ + "static/media/chz.73759860e134824ce005a3a8cfd37452.svg";
export { ForwardRef as ReactComponent };